import { getNoticeJSON } from '@/api/login';
import '@/assets/css/tailwind.css';
import { BRAND_NAME, brandEnvConfig, brandGlobalConfig, getBrand, isXwyk } from '@/brandConfig';
import showBrandModal from '@/components/ChooseBrand/index';
import { useLoginProvide } from '@/hooks/login';
import router from '@/router';
import __bl from '@/utils/arms-logger';
import { deleteSearch, getQueryVariable } from '@/utils/http';
import { getUrlParams } from '@/utils/urlParse';
import STable from '@surely-vue/table';
import '@surely-vue/table/dist/index.less';
import { createPinia } from 'pinia';
import 'virtual:svg-icons-register';
import { createApp } from 'vue';
import App from './app';
import './assets/css/global.less';
import { sendLog } from './log';
import { inLog } from './log/pages/common';
import { handleStuDetailJupm, handleStuDetailJupmParams } from './pages/studentDetail/handleStuJump';
import commonStore from './store/common';

const pinia = createPinia();
const app = createApp(App).use(pinia).use(STable);
const urlOrigin = window.location.origin;
const xiwangUrl = urlOrigin.includes('xiwang');

// 接入公告
const showGongGao = async () => {
  const brand = getBrand();
  const jsonUrl = `${brandEnvConfig.gongGaoJsonUrl}?t=${Date.now()}`;
  // 已打开过一次公告则且公告内容未改变过 则不再展示公告
  const res = await getNoticeJSON(jsonUrl);
  const showNotice = localStorage.getItem(`showNotice${brand}`);
  const noticeLabel = localStorage.getItem(`noticeLabel${brand}`);
  if (showNotice && noticeLabel === res.label) {
    // 表示已经展示过
    return; // 不展示通知弹窗
  }
  if (window.createNotice && res.ifShow) {
    window.createNotice({
      id: 'my-class-notice',
      parentId: 'app',
      jsonUrl,
      type: 'info',
      closeable: true,
      closeCallback: () => {
        // 用户点击关闭 存储数据
        localStorage.setItem(`showNotice${brand}`, true);
        localStorage.setItem(`noticeLabel${brand}`, res.label);
      }
    });
  }
};
(async () => {
  let userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null');
  let hasLogin = JSON.parse(localStorage.getItem('hasLogin') || 'false');
  const token = getQueryVariable('token') || '';
  handleStuDetailJupmParams();
  // 非开发环境
  if (import.meta.env.VITE_APP_ENV !== 'dev') {
    // 分两种情况去处理 1、已经分配角色，则登录后直接弹出选择品牌弹窗，选择弹窗后正常展示页面 2、未分配角色，登录后先弹出品牌选择弹窗，选择完品牌后再弹出选择角色弹窗，选择完角色后正常进入页面
    const login = useLoginProvide();
    // 未登录
    if (!hasLogin || !userInfo) {
      // 有token, 请求接口
      if (token) {
        if (xiwangUrl && !localStorage.getItem(BRAND_NAME)) {
          showBrandModal();
          return;
        }
        userInfo = await login.getUserInfo();
        if (userInfo && Object.prototype.toString.call(userInfo) === '[object Object]') {
          // 登录成功后，保存状态，删除search
          hasLogin = true;
          sessionStorage.removeItem('newCourseInfo');

          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          localStorage.setItem('hasLogin', JSON.stringify(hasLogin));
          deleteSearch();
        }
      } else {
        login.toLoginOut();
      }
    }
  } else {
    // 本地开发免登录
    hasLogin = true;
  }
  if (hasLogin) {
    const { brandSource = null } = getUrlParams(window.location.href) || {};
    // brandSource,外部链接主体来源
    // 如果是希望学/素养，则判断从外部链接跳转过来是否携带brandSource
    // 如果携带并且不等于缓存中的，则认为从外部携带过来的主体与当前主体不一致，做退出登录操作
    const localStorageBrand = localStorage.getItem(BRAND_NAME) || '';
    if (brandSource && localStorageBrand && brandSource !== localStorageBrand) {
      const login = useLoginProvide();
      login.toLoginOut();
    }
    handleStuDetailJupm();
  }

  return {
    hasLogin,
    userInfo
  };
})()
  .then(async (data: any) => {
    if (data?.hasLogin) {
      const common = commonStore();
      common.userInfo = data.userInfo;
      common.hasLogin = data.hasLogin;
      sendLog(inLog, {}); // 曝光埋点
      // 更新ARMS公共参数 uid userName
      if (data.userInfo) {
        __bl.setConfig({
          uid: data.userInfo.workcode,
          setUsername() {
            return data.userInfo.account_name || data.userInfo.name;
          }
        });
      }

      const localStorageBrand = localStorage.getItem(BRAND_NAME) || '';
      if (localStorageBrand || isXwyk) {
        const dom: any = document.getElementById('favicon');
        if (dom) {
          dom.href = brandGlobalConfig.favicon;
        }
        await common.getMenuList();
        common.brand = localStorageBrand;
        showGongGao();
      } else {
        // 希望学/希望素养需要做品牌选择页面
        showBrandModal();
      }
      app.use(router);

      app.mount('#app');
    }
  })
  .catch((e: any) => {
    return Promise.reject(e);
  });
